/**
 * Estado de una corrida de Resumen CX para la pantalla (feature 025).
 * Sin componentes de UI a propósito: se testea sin renderizar Cloudscape.
 */

/**
 * «Volver a generar» sólo para corridas manuales fallidas (T091, FR-029): una quincenal
 * automática la reemplaza el cierre del día siguiente con el mismo id, y un reintento manual
 * dejaría dos reportes del mismo período. Un registro sin origin se lee como manual (FR-024).
 */
export function canRetryRun(run) {
  if (!run || run.status !== 'FAILED') return false;
  return (run.origin || 'MANUAL') !== 'BIWEEKLY_AUTO';
}

/** Texto del motivo de falla: los motivos con nombre (data-model §1) dicen qué hacer. */
export function failureReasonText(run, t) {
  const reason = run?.failureReason;
  if (!reason) return null;

  if (reason === 'exceeds_cap') {
    const withCx = (Number(run.callsFound) || 0) - (Number(run.callsWithoutCx) || 0);
    const max = Number(run.maxCallsPerRun) || 0;
    return t('insights.detail.failureExceedsCap', {
      withCx,
      max,
      defaultValue: `No se generó: el filtro tenía ${withCx} llamadas con análisis y el máximo por resumen es ${max}. Acotá las fechas.`,
    });
  }

  const named = {
    no_cx_material: 'Ninguna llamada del filtro tenía análisis de experiencia.',
    enqueue_failed: 'No se pudo iniciar la generación. Volvé a intentarlo.',
    timed_out: 'La generación tardó más de lo permitido y se detuvo.',
    consolidation_prompt_missing: 'Falta configurar el prompt de consolidación de la instalación.',
  };
  if (named[reason]) {
    const key = reason.replace(/_([a-z])/g, (_, c) => c.toUpperCase());
    return t(`insights.detail.failure_${key}`, { defaultValue: named[reason] });
  }

  return t('insights.detail.failureReason', {
    reason,
    defaultValue: `La generación falló: ${reason}`,
  });
}
